import './styles/index.less'
// 引入组件
import Icon from './components/icon'
import Button from './components/button'
import Switch from './components/switch'
import { Breadcrumb, BreadcrumbItem } from './components/breadcrumb'
import { NavSliderMenu, NavSliderSubMenu, NavSliderItem } from './components/navSliderMenu'
import Pagination from './components/pagination'
import { Select, Option } from './components/select'
import { Tab, Tabs } from './components/tabs'
import Dialog from './components/dialog'
import { Checkbox, CheckboxGroup } from './components/checkbox'
import { Radio, RadioGroup } from './components/radio'
import { Row, Col } from './components/grid'
import Message from './components/message'
import Popover from './components/popover'
import SearchInput from './components/searchInput'
import Notification from './components/notification'
import Input from './components/input'
import State from './components/state'
import Table from './components/table'
import SearchSelect from './components/searchSelect'
import ButtonGroup from './components/buttongroup'
import { Form, FormItem } from './components/form'
import Upload from './components/upload'
import Verification from './components/verification'
// 引入指令
import Clickoutside from './directives/clickoutside'
import Infinite from './directives/infinite'

const components = {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  Col,
  Dialog,
  Icon,
  Input,
  NavSliderMenu,
  NavSliderSubMenu,
  NavSliderItem,
  Option,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Row,
  SearchInput,
  SearchSelect,
  Select,
  State,
  Switch,
  Tab,
  Tabs,
  Table,
  Form,
  FormItem,
  Upload,
  Verification
}

const directives = {
  Clickoutside,
  Infinite
}

const install = function (Vue) {
  for (let component in components) {
    Vue.component(components[component].name, components[component])
  }

  for (let directive in directives) {
    directives[directive].install(Vue)
  }

  Vue.prototype.$message = Message
  Vue.prototype.$notify = Notification
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  Breadcrumb as BccBreadcrumb,
  BreadcrumbItem as BccBreadcrumbItem,
  Button as BccButton,
  ButtonGroup as BccButtonGroup,
  Checkbox as BccCheckbox,
  CheckboxGroup as BccCheckboxGroup,
  Col as BccCol,
  Dialog as BccDialog,
  Icon as BccIcon,
  Input as BccInput,
  NavSliderMenu as BccNavSliderMenu,
  NavSliderSubMenu as BccNavSliderSubMenu,
  NavSliderItem as BccNavSliderItem,
  Option as BccOption,
  Pagination as BccPagination,
  Popover as BccPopover,
  Radio as BccRadio,
  RadioGroup as BccRadioGroup,
  Row as BccRow,
  SearchInput as BccSearchInput,
  SearchSelect as BccSearchSelect,
  Select as BccSelect,
  State as BccState,
  Switch as BccSwitch,
  Tab as BccTab,
  Table as BccTable,
  Tabs as BccTabs,
  Form as BccForm,
  FormItem as BccFormItem,
  Clickoutside,
  Infinite,
  Message,
  Notification,
  Verification as BccVerification
}

export default {
  ...components,
  ...directives,
  Message,
  Notification,
  install
}
